// Spring system Framer Motion presets — référence : docs/07-ux-ui-motion.md §3.1
export const springs = {
  snap: { type: 'spring', stiffness: 600, damping: 30 },
  gentle: { type: 'spring', stiffness: 260, damping: 20 },
  firm: { type: 'spring', stiffness: 180, damping: 26 },
  wobbly: { type: 'spring', stiffness: 240, damping: 14 },
  none: { duration: 0 },
} as const;

export const easings = {
  apple: [0.25, 0.1, 0.25, 1] as const,
  kinetic: [0.4, 0, 0.2, 1] as const,
  exit: [0.4, 0, 1, 1] as const,
  enter: [0, 0, 0.2, 1] as const,
} as const;

export const durations = {
  micro: 100,
  fast: 150,
  base: 200,
  slow: 300,
  page: 400,
} as const;
